export const INPUT_KEYS = {
  ENTER_KEY: 'Enter',
  ESCAPE_KEY: 'Escape',
};
